import { render } from "./AuthItemGroupView.vue?vue&type=template&id=3f4331b2&scoped=true"
import script from "./AuthItemGroupView.vue?vue&type=script&lang=js"
export * from "./AuthItemGroupView.vue?vue&type=script&lang=js"

import "./AuthItemGroupView.vue?vue&type=style&index=0&id=3f4331b2&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f4331b2"]])

export default __exports__